import { handleActions } from 'redux-actions';

import { MODAL_CLOSE, MODAL_OPEN } from '../constants/Constants';

const initialState = {};

export default handleActions(
  {
    [MODAL_CLOSE]: (state, { payload: { id, ...data } }) => ({
      ...state,
      [id]: { ...state[id], open: false, ...data }
    }),
    [MODAL_OPEN]: (state, { payload: { id, ...data } }) => ({ ...state, [id]: { ...state[id], open: true, ...data } })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/ModalsReducer.js